import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useNavigate } from "react-router-dom";
import { LG } from "../../../styles/liquidGlass";
import { useTemplateConfig } from "../../../templates/templateConfigContext";

export const Logo: React.FC<{ isScrolled: boolean }> = ({ isScrolled }) => {
    const navigate = useNavigate();
    const { config } = useTemplateConfig();

    return (
        <Box
            onClick={() => navigate("/")}
            sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                userSelect: "none",
            }}
        >
            <Typography
                sx={{
                    fontSize: isScrolled ? "1.15rem" : "1.35rem",
                    fontWeight: 600,
                    letterSpacing: "0.22em",
                    color: LG.color.text,
                    transition: "font-size 0.3s ease",
                    textTransform: "uppercase",
                    lineHeight: 1,
                }}
            >
                {config.identidad.vchNombreTienda}
            </Typography>
        </Box>
    );
};
